<template>
  <v-layout>
    <v-flex
      xs-6
      shrink
      class="coupon-name"
    >
      <div class="font-weight-medium">
        {{ coupon.name }}
      </div>
      <div v-if="showType">
        {{ $t('Type') }}: {{ coupon.discount_type }}
      </div>
    </v-flex>
    <v-flex
      :class="$vuetify.rtl | rtlTextAlign"
      class="grey--text"
    >
      <div v-if="coupon.code">
        {{ $t('Code') }}: {{ coupon.code }}
      </div>
      <div v-if="coupon.rate_type === 'percentage'">
        {{ $t('Rate') }}: {{ coupon.rate }}%
      </div>
      <div
        v-else
        class="text-capitalize"
      >
        {{ coupon.rate_type }}
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'OrderAppliedDiscountLine',

  props: {
    coupon: {
      type: Object,
      required: true
    },
    showType: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
.coupon-name {
  max-width: 250px;
}
</style>
